import React from 'react';
import { Row } from 'react-table';
import { withPlaceholder } from 'HOC';
import { Header } from 'layout';
import { useGetContributions } from 'hooks/api/contributions';
import { useNavigate } from 'hooks/routes';
import RenderContributionsTable from '../components/RenderContributionsTable';
import { ContributionTableSign, mapData } from './ContributionsTable.columns';
import ImportCsv from '../components/ImportCsv';
import RefreshContributions from '../components/RefreshContributions/RefreshContributions';

import messages from './ContributionsTable.messages';

const RenderTablewithPlaceholders = withPlaceholder(RenderContributionsTable);

const ContributionsTable = (): JSX.Element => {
  const {
    data: contributionsListData,
    isLoading,
    isError,
    refetch,
    isRefetching,
  } = useGetContributions();
  const { toContributionDetails } = useNavigate();

  const items = mapData(contributionsListData?.items);

  const onContributionClick = (row: Row<ContributionTableSign>) => {
    toContributionDetails(row.original.id, {
      transferId: row.original.externalId,
      status: row.original.status,
    });
  };

  return (
    <>
      <Header title={messages.headerTitle}>
        <RefreshContributions />
        <ImportCsv />
      </Header>

      <RenderTablewithPlaceholders
        contributionsListData={contributionsListData}
        items={items}
        onContributionClick={onContributionClick}
        refetch={refetch}
        isRefetching={isRefetching}
        isLoading={isLoading}
        isError={isError}
        isData={!!items && items?.length !== 0}
      />
    </>
  );
};

export default ContributionsTable;
